module.exports = __webpack_public_path__ + "img/flame-close.716aa685.svg";